<template>
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">        
        <path
            d="M30.3729 19H21.3729C20.2683 19 19.3729 19.8954 19.3729 21V30C19.3729 31.1046 20.2683 32 21.3729 32H30.3729C31.4774 32 32.3729 31.1046 32.3729 30V21C32.3729 19.8954 31.4774 19 30.3729 19Z"
            stroke="#398FE6"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.3729 25H14.3729C13.8424 25 13.3337 24.7893 12.9587 24.4142C12.5836 24.0391 12.3729 23.5304 12.3729 23V14C12.3729 13.4696 12.5836 12.9609 12.9587 12.5858C13.3337 12.2107 13.8424 12 14.3729 12H23.3729C23.9033 12 24.412 12.2107 24.7871 12.5858C25.1621 12.9609 25.3729 13.4696 25.3729 14V15"
            stroke="#398FE6"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>